import { jsxs, jsx } from 'react/jsx-runtime';
import { useState } from 'react';
import { Alert } from '@zooplus/ui-components';
import BaseModal from '../BaseModal/BaseModal.js';
import styles from '../BaseModal/BaseModal.module.scss.js';
import CreditCardNew from '../../../CreditCardNew/CreditCardNew.js';
import { useTranslation } from '../../../../hooks/useTranslations.js';
import { useCreditCardContext } from '../../../../providers/CreditCardContextProvider.js';
import { useOverlays, OverlayIds } from '../../../../providers/OverlaysProvider.js';

/**
 * Modal to make the customer confirms that he really wants to delete the given stored credit card.
 * Independent from the actual payment service provider.
 */
const DeleteCardModalNew = () => {
    const { t } = useTranslation();
    const { cardToDelete, deleteHandler } = useCreditCardContext();
    const [deleteCardError, setDeleteCardError] = useState();
    const [deleteCardLoading, setDeleteCardLoading] = useState(false);
    const { hideOverlay } = useOverlays();
    if (!cardToDelete)
        return null;
    const handleDeleteCard = () => {
        setDeleteCardLoading(true);
        setDeleteCardError(undefined);
        deleteHandler?.();
        hideOverlay(OverlayIds.DELETE_CARD_NEW);
        setDeleteCardLoading(false);
    };
    return (jsxs(BaseModal, { modalId: OverlayIds.DELETE_CARD_NEW, disabledPrimaryBtn: deleteCardLoading, disabledSecondaryBtn: deleteCardLoading, isLoading: deleteCardLoading, handleSubmit: handleDeleteCard, heading: t('checkout.payment.creditcard.delete'), primaryButtonLabel: t('general.button.delete'), headingId: `delete-card-${cardToDelete?.pspIdentifier}`, closeBtnAriaLabel: t('checkout.payment.creditcard.delete'), dataZta: "modal-removeCard", size: "sm", children: [deleteCardError && (jsx(Alert, { className: styles.errorMessage, variant: "warning", children: deleteCardError })), jsx("div", { className: styles.confirmDeleteMessage, children: t('checkout.payment.creditcard.delete.confirm') }), jsx("div", { className: styles.confirmDeleteCardContainer, children: cardToDelete && jsx(CreditCardNew, { creditCard: cardToDelete, showIcons: false }) })] }));
};

export { DeleteCardModalNew as default };
//# sourceMappingURL=DeleteCardModalNew.js.map
